import { PROGRAM_ID } from '@metaplex-foundation/mpl-candy-machine';
import { CandyMachineV2GpaBuilder } from './gpaBuilders.mjs';

/** @group Programs */
const CandyMachineV2Program = {
  publicKey: PROGRAM_ID,
  accounts(metaplex) {
    return new CandyMachineV2GpaBuilder(metaplex, this.publicKey);
  }
};

export { CandyMachineV2Program };
//# sourceMappingURL=program.mjs.map
